<template>
    <CompassModal
        v-model:visible="showModal"
        :title="$t.__('email.SetUpProviderModal.title')"
        :primaryAction="primaryAction"
        :closeOnClickOverlay="false"
        class="email-setup-provider-warning-modal"
    >
        <template #default>
            <div class="email-setup-provider-warning-modal__content">
                <div class="email-setup-provider-warning-modal__illustration">
                    <img src="/ressources/logged/img/illustrations/disconnected.svg" />
                </div>

                <div class="email-setup-provider-warning-modal__informations">
                    <span class="typographies-paragraph-large-bold">
                        {{ $t.__('email.SetUpProviderModal.informations.title') }}
                    </span>
                    <br />
                    <span class="typographies-paragraph-medium-regular" v-html="subtitle" />
                </div>

                <div class="email-setup-provider-warning-modal__benefits">
                    <div class="email-setup-provider-warning-modal__benefits-illustration">
                        <img src="/ressources/logged/img/illustrations/provider-email.svg" />
                    </div>
                    <ul class="email-setup-provider-warning-modal__benefits-list">
                        <li
                            v-for="(benefit, index) in benefits"
                            :key="index"
                            class="email-setup-provider-warning-modal__benefits-list-item typographies-paragraph-medium-regular"
                            v-html="benefit"
                        />
                    </ul>
                </div>
            </div>
        </template>
    </CompassModal>
</template>

<script>
const startStrong = '<span class="typographies-paragraph-medium-bold">';
const endStrong = '</span>';

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: this.isVisible,
            primaryAction: {
                label: this.$t.__('email.SetUpProviderModal.actions.confirm'),
                action: () => {
                    this.$emit('close');
                },
            },
            subtitle: this.$t.__('email.SetUpProviderModal.informations.subtitle', {
                startStrong: startStrong,
                endStrong: endStrong,
            }),
            benefits: [
                this.$t.__('email.SetUpProviderModal.benefits.item1', {
                    startStrong: startStrong,
                    endStrong: endStrong,
                }),
                this.$t.__('email.SetUpProviderModal.benefits.item2', {
                    startStrong: startStrong,
                    endStrong: endStrong,
                }),
                this.$t.__('email.SetUpProviderModal.benefits.item3', {
                    startStrong: startStrong,
                    endStrong: endStrong,
                }),
            ],
        };
    },
    watch: {
        isVisible(newValue) {
            this.showModal = newValue;
        },
    },
};
</script>

<style lang="scss" scoped>
.email-setup-provider-warning-modal {
    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: var(--spacing-4);
    }

    &__informations {
        text-align: center;
        margin-bottom: var(--spacing-1);
    }

    &__benefits {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: var(--spacing-2);
        padding: 20px;
        border-radius: var(--spacing-3);
        background-color: var(--colors-common-background-primary-subtle);

        &-list {
            margin: 0;
            padding-left: var(--spacing-4);
            list-style-type: disc;
        }
    }

    :deep(.compass-modal__modal__header) {
        .compass-icon-button {
            display: none;
        }
    }
}
</style>
